import { getActiveKey } from './KeyManager';
import { getConfig } from '../utils/networkConfigStore';
import { LocalKeyStrategy } from './LocalKeyStrategy';
import type { SigningStrategy } from './SigningStrategy';

/**
 * Build a LocalKeyStrategy for the current custom network session.
 * Returns null if not on a custom network or key/config is missing.
 */
export function buildCustomStrategy(
  connectedNetwork: string | undefined,
  accountId: string,
): SigningStrategy | null {
  if (!connectedNetwork?.startsWith('custom-')) return null;

  const activeKey = getActiveKey();
  const config = getConfig(connectedNetwork);
  if (!activeKey || !config) return null;

  return new LocalKeyStrategy(activeKey, accountId, config);
}
